/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { SetLeadAssignments200ResponseData } from './SetLeadAssignments200ResponseData';
import {
    SetLeadAssignments200ResponseDataFromJSON,
    SetLeadAssignments200ResponseDataFromJSONTyped,
    SetLeadAssignments200ResponseDataToJSON,
} from './SetLeadAssignments200ResponseData';

/**
 * 
 * @export
 * @interface SetLeadAssignments200Response
 */
export interface SetLeadAssignments200Response {
    /**
     * 
     * @type {SetLeadAssignments200ResponseData}
     * @memberof SetLeadAssignments200Response
     */
    data: SetLeadAssignments200ResponseData;
}

/**
 * Check if a given object implements the SetLeadAssignments200Response interface.
 */
export function instanceOfSetLeadAssignments200Response(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "data" in value;

    return isInstance;
}

export function SetLeadAssignments200ResponseFromJSON(json: any): SetLeadAssignments200Response {
    return SetLeadAssignments200ResponseFromJSONTyped(json, false);
}

export function SetLeadAssignments200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SetLeadAssignments200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': SetLeadAssignments200ResponseDataFromJSON(json['data']),
    };
}

export function SetLeadAssignments200ResponseToJSON(value?: SetLeadAssignments200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': SetLeadAssignments200ResponseDataToJSON(value.data),
    };
}

